import angular from 'angular'
import collectionCtrl from './controller/collecitonCtrl'
import { collectionExport } from 'redevConfig'
const page = (collectionExport && collectionExport.page) || ''

const collectionExportPage = page ? require(`redevelopment/outputManage/collectionExport/${page.templateName}`) : require('./view/collectionExport.html')
const collectionExportCtrl = page ? require(`redevelopment/outputManage/collectionExport/${page.controllerName}`) : require('./controller/collectionExportCtrl')
// NOTE: 配置子路由
const config = ($stateProvider) => {
    $stateProvider
        .state('outputManage.taxFilling.collection', {
            abstract: true,
            url: '/collection',
            template: '<div ui-view></div>',
            // controller: 'collectionCtrl',
            // title: '报税管理',
            default: 'outputManage.taxFilling.collection.export',
        })
        .state('outputManage.taxFilling.collection.export', {
            url: '/export',
            template: collectionExportPage,
            controller: 'collectionExportCtrl',
            title: '上报汇总处理',
        })
}

export default angular
    .module('outputManage.taxFilling.collection', [])
    .config(['$stateProvider', config])
    .controller('collectionCtrl', collectionCtrl)
    .controller('collectionExportCtrl', collectionExportCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/outputManage/taxFilling/collectionExport/index.js